import { render } from "./CreateSimilarTestView.vue?vue&type=template&id=4e6f0372&scoped=true"
import script from "./CreateSimilarTestView.vue?vue&type=script&lang=js"
export * from "./CreateSimilarTestView.vue?vue&type=script&lang=js"

import "./CreateSimilarTestView.vue?vue&type=style&index=0&id=4e6f0372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6f0372"]])

export default __exports__